import * as React from 'react';
import * as ReactDOM from 'react-dom';

import KendoBaseComponent, { KendoWidgetProps } from '@progress/kendo-base-component-react-wrapper';

export interface MenuProps extends KendoWidgetProps, kendo.ui.MenuOptions {
    children?: React.ReactNode;
}

export default class Menu extends KendoBaseComponent<MenuProps, {}> {
    componentDidMount(): void {
        const domNode = this.domNode;
        const { children, widgetRef, ...props } = this.props;

        if (domNode) {
            this.widgetInstance = new kendo.ui.Menu(domNode as Element, (props as kendo.ui.MenuOptions));
            super.componentDidMount();
        }
    }

    render(): any {
        if (this.domNode) {
            const { children, widgetRef, ...props } = this.props;
            const widget = (this.widgetInstance as kendo.ui.Menu);

            if (props.dataSource && props.dataSource === widget.options.dataSource) {
                delete props.dataSource;
            }

            this.widgetInstance.setOptions(props);
        }

        return (
            <ul ref={this.elementRef}>
                {this.props.children}
            </ul>
        );
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-layout-react-wrapper/src/menu/menu.tsx